var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBackgroundImage = function SvgBackgroundImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 912,
    height: 335,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.727 112.006H39.602c4.229-3.525 10.318-10.234 16.07-13.956 7.189-4.652 13.11 1.692 20.299 5.921s5.92.845 13.532.845c6.09 0 12.687 4.793 15.224 7.19ZM411.749 109.105h53.284c-3.46-2.868-8.442-8.33-13.148-11.359-5.882-3.786-10.726 1.377-16.608 4.819s-4.844.688-11.072.688c-4.983 0-10.38 3.901-12.456 5.852ZM212.988 87.115h-98.111c6.371-5.355 15.545-15.549 24.209-21.203 10.831-7.067 19.75 2.57 30.58 8.995 10.831 6.425 8.92 1.285 20.387 1.285 9.174 0 19.113 7.282 22.935 10.923Z",
    stroke: "#191A1E",
    strokeWidth: 0.846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m278.96 231.311-126.023-23.006L3.232 271.57v59.979h459.264V199.678l-41.444 8.627-61.742-20.54-80.35 43.546Z",
    fill: "#EAEFF0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m495.905 172.117-38.484 32.14-46.518 21.568-41.444 16.136h-85.847l-23.682 32.835h-95.744l-18.269 6.936-17.929 6.85h-.002l-105.3 23.047-21.99 23.048h495.209v-162.56Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M300.721 217.54c-.212.426-4.152-2.236-5.11 4.365l-7.347 30.985h10.541l2.023-9.583 6.176 9.583h35.244s-1.491-12.777-26.939-19.272l2.875-8.518s.639-1.491-1.278-2.875",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M300.721 217.54c-.212.426-4.152-2.236-5.11 4.365l-7.347 30.985h10.541l2.023-9.583 6.176 9.583h35.244s-1.491-12.777-26.939-19.272l2.875-8.518s.639-1.491-1.278-2.875",
    stroke: "#191A1E",
    strokeWidth: 0.846,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m305.3 208.063-6.495 13.736c1.277.852 2.662 1.81 4.152 2.555 2.875 1.385 6.176 1.491 9.157.533l3.94-1.278 3.94-8.305-14.694-7.241Z",
    fill: "#fff",
    stroke: "#191A1E",
    strokeWidth: 0.846,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M232.018 101.663c-.676-2.875-.676-6.512.339-9.303 1.522-3.976 7.866-16.24 9.134-18.1 2.538-3.553 5.836-4.99 10.15-4.99 3.975 0 17.93 5.328 20.045 7.273 2.96 2.622 2.199 5.498 2.199 5.498",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M232.018 101.663c-.676-2.875-.676-6.512.339-9.303 1.522-3.976 7.866-16.24 9.134-18.1 2.538-3.553 5.836-4.99 10.15-4.99 3.975 0 17.93 5.328 20.045 7.273 2.96 2.622 2.199 5.498 2.199 5.498",
    stroke: "#191A1E",
    strokeWidth: 0.846,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m273.97 82.04-24.19 51.763c-1.353 2.791-4.144 4.652-7.273 4.652h-7.443c-7.443 0-12.941-6.09-12.941-12.941 0-1.86.423-3.721 1.269-5.497l8.627-18.354c1.522-3.298 3.129-6.513 4.652-9.811 2.03-4.314 3.975-8.543 6.089-12.856 1.1-2.284 3.383-3.468 5.921-3.552a11.887 11.887 0 0 1 6.174 1.438l6.851 3.721a14.85 14.85 0 0 0 2.706 1.015l9.558.423Z",
    fill: "#fff",
    stroke: "#191A1E",
    strokeWidth: 0.846,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m264.413 81.62-.931 1.86",
    stroke: "#191A1E",
    strokeWidth: 0.846,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m262.046 86.694-22.413 48.21",
    stroke: "#191A1E",
    strokeWidth: 0.846,
    strokeMiterlimit: 10,
    strokeDasharray: "4.36 4.36"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m238.871 136.511-.846 1.945",
    stroke: "#191A1E",
    strokeWidth: 0.846,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M231.427 121.878c-2.537-1.438-3.468-4.568-2.199-7.19l4.737-9.557c.507-1.015 1.776-1.438 2.791-.846a6.545 6.545 0 0 0 2.706 2.791c1.438.762 2.876.762 3.383.762.085.084.677.422.931 1.099.169.508.084 1.015-.085 1.438l-4.567 9.219c-1.438 2.791-4.906 3.806-7.697 2.284Z",
    fill: "#BFC3D1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M343.663 252.552c-.592 0-1.1-.507-1.015-1.099L362.27 70.708c.085-.508.508-.93 1.015-.93.592 0 1.1.507 1.015 1.099l-19.622 180.745c-.085.507-.508.93-1.015.93Z",
    fill: "#191A1E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M210.807 251.996c-.223.446-4.348-2.341-5.351 4.57l-7.692 32.442H208.8l2.119-10.034 6.465 10.034h36.901s-1.561-13.378-28.205-20.179l3.01-8.918s.669-1.561-1.338-3.01",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M210.807 251.996c-.223.446-4.348-2.341-5.351 4.57l-7.692 32.442H208.8l2.119-10.034 6.465 10.034h36.901s-1.561-13.378-28.205-20.179l3.01-8.918s.669-1.561-1.338-3.01",
    stroke: "#191A1E",
    strokeWidth: 0.886,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m215.601 242.075-6.8 14.381c1.338.892 2.787 1.896 4.348 2.676 3.01 1.449 6.466 1.561 9.587.557l4.125-1.337 4.125-8.696-15.385-7.581Z",
    fill: "#fff",
    stroke: "#191A1E",
    strokeWidth: 0.886,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M336.896 217.197v1.354c0 1.945-.677 3.89-2.03 5.413l-3.468 4.06c-1.438 1.691-3.721 2.199-5.751 1.353a59.146 59.146 0 0 1-11.249-6.005c-8.458-5.752-13.787-12.603-16.916-17.593-.846-1.353-.846-3.045 0-4.313l2.03-3.299c.93-1.522 2.368-2.706 4.06-3.383.592-.254 1.184-.507 1.776-.677",
    fill: "#264C59"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M317.105 179.053h-44.912l14.379-36.285h37.722c35.861-.761 40.852 26.643 27.996 48.295l-17.508 29.687s-23.682-4.229-31.294-24.528l19.453-24.528M249.78 240.626s3.806 4.652 2.537 6.174c0 0-3.806 6.936-3.806 7.02-2.706 3.13-11.164 2.707-12.348 2.538-2.96-.339-19.03-2.03-28.588-15.986-2.368-3.468-3.637-6.597-4.313-8.627.338-1.269 1.015-3.298 2.537-5.244.592-.761 1.861-2.283 4.06-3.383.761-.338 1.353-.592 1.776-.677",
    fill: "#264C59"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M245.383 142.092s-2.792 13.532-7.866 18.607c-12.095 12.095-9.896 16.662-12.687 26.22-2.368 8.035-1.692 11.079-5.075 20.299-2.03 5.497-9.134 17.338-10.741 20.129a32.368 32.368 0 0 0 5.92 8.458c8.881 9.135 28.842 11.926 34.255 10.234.169-12.856 8.965-29.518 11.502-34 .508-.931 2.876-4.906 5.667-10.573 2.791-5.667 3.552-7.95 3.891-8.881.846-2.791 1.353-5.92 1.945-11.587.846-7.612 10.995-23.682 10.995-23.682s4.229-8.796 3.384-14.548l-41.19-.676Z",
    fill: "#264C59"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M286.318 84.578c1.523.085 6.936.338 10.15 2.115a17.655 17.655 0 0 1 5.751 4.99s-.423 8.711 0 8.288c.423-.422-12.264-9.219-12.264-9.219l-3.637-6.174Z",
    fill: "#EAEFF0",
    stroke: "#191A1E",
    strokeWidth: 0.846,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M303.489 120.101c-.085 3.722-.423 8.796-1.185 14.463-.338 2.622-.845 5.413-1.353 8.204l-57.513-.676s18.691-46.096 22.328-51.001c.169-.254.423-.592.677-.846 3.383-4.145 7.95-6.174 12.687-6.513 1.268-.084 2.453-.084 3.721.085 2.707.338 5.329 1.1 7.782 2.368 2.706 1.438 5.243 3.383 7.273 5.751.508.592.931 1.185 1.354 1.861 2.537 3.89 3.721 8.458 4.144 13.279.338 4.398.169 8.881.085 13.025Z",
    fill: "#EAEFF0",
    stroke: "#191A1E",
    strokeWidth: 0.846,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M336.812 131.097h1.1",
    stroke: "#191A1E",
    strokeWidth: 0.846,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M336.812 131.097c-.508 1.1-1.1 2.03-1.607 2.791-.423.592-1.015.931-1.692.931-.338 0-.676-.085-1.015-.254-.084-.085-.169-.085-.253-.169-1.354-.846-2.369-2.03-3.13-3.383l7.697.084Z",
    fill: "#191A1E",
    stroke: "#191A1E",
    strokeWidth: 0.846,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M332.498 134.564c.338.169.677.253 1.015.253-8.543.17-16.831.593-22.16.339-3.383-.169-6.428-.339-9.05-.592-12.094-1.1-16.662-2.707-19.537-3.975-4.229-1.861-8.797-3.891-12.603-8.628-6.597-8.119-6.005-17.676-6.005-20.637 0-3.806.592-7.866 2.199-11.08 2.03-4.06 5.667-6.85 12.01-6.512.254 0 .423 0 .677.084 10.742.93 10.826 12.349 10.826 12.349v10.149c2.453.508 5.667.846 9.642.846h3.806c6.767.085 14.294.339 20.384.508 6.597.253 11.418.507 11.418.507a9.414 9.414 0 0 0-2.876 1.184c-4.99 3.13-5.074 10.319-5.074 12.264 0 1.015-.085 5.752 2.029 9.473.762 1.353 1.777 2.537 3.13 3.383 0 0 .084 0 .169.085Z",
    fill: "#EAEFF0",
    stroke: "#191A1E",
    strokeWidth: 0.846,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M281.498 102.763s1.861 2.283 8.289 3.467",
    stroke: "#191A1E",
    strokeWidth: 0.846,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M347.637 74.598v.338c-.085.17-.254.339-.508.339l-5.074.253v-3.214c0 .254.169.423.423.508l4.736 1.353c.254 0 .423.254.423.423Z",
    fill: "#191A1E",
    stroke: "#191A1E",
    strokeWidth: 0.846,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m363.03 70.284-1.86 17.085-15.14 1.269-.592 4.652-18.692.676 2.199-17.93 13.11-.593 5.075-.253c.253 0 .423-.17.507-.339 0-.084.085-.169 0-.338 0-.169-.169-.423-.423-.507l-4.736-1.354c-.254-.084-.423-.253-.423-.507v-.17c0-.253.254-.422.592-.507l20.383-1.184Z",
    fill: "#989A41"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M323.702 81.872v25.712c-6.09-.254-13.617-.507-20.384-.507-.423-4.737-1.607-9.389-4.144-13.28v-12.01c0-.93.169-1.86.592-2.79.423-.93 1.184-1.861 2.368-1.861v4.144s.93 2.453 9.811 2.453 9.642-2.368 9.642-3.383v-3.045c.592.423 2.115 1.691 2.115 4.567Z",
    fill: "#EAEFF0",
    stroke: "#191A1E",
    strokeWidth: 0.846,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M321.503 69.438V80.35c0 1.015-.761 3.383-9.642 3.383s-9.811-2.453-9.811-2.453V70.284c0-.676-.254-1.353-.761-1.86-.423-.423-.846-1.015-1.354-1.777-1.015-1.776-2.199-.93-2.452-3.13-1.015-.591-1.692-1.606-1.692-2.875 0-2.03 1.607-3.468 3.383-4.06 1.015-.338 2.115-.338 3.13-.338h3.975c1.522 0 3.129.592 4.313 1.607 1.776.17 3.722 1.015 4.568 2.538l1.776.507c3.637 1.438 4.567 4.99 4.567 8.542Z",
    fill: "#fff",
    stroke: "#191A1E",
    strokeWidth: 0.846,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M321.502 77.305c-.253-.17-.338-.17-.338-.17M297.566 63.518c.254 2.114 1.438 1.268 2.453 3.044.508.846.931 1.438 1.353 1.861.508.508.762 1.184.762 1.86v6.852M315.752 67.493c-3.045 0-5.328.085-6.935.17-1.523 0-3.637.084-4.652-1.354-.93-1.268-.846-3.214.338-4.313 1.523-1.354 4.145-1.692 6.09-1.86 2.114-.17 4.398-.086 6.428.76 3.552 1.353 4.483 4.99 4.483 8.458v7.866M311.861 67.493v3.13",
    stroke: "#191A1E",
    strokeWidth: 0.846,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m314.821 60.727.423-.254c-1.015-1.607-3.129-2.538-5.075-2.538h-3.975c-1.015 0-2.114 0-3.129.339-1.776.592-3.383 2.114-3.383 4.06 0 2.114 2.03 3.636 4.059 3.214",
    stroke: "#191A1E",
    strokeWidth: 0.846,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M299.851 63.856c-1.946.508-3.975-1.1-4.06-3.214 0-2.03 1.607-3.468 3.383-4.06 1.015-.338 2.115-.338 3.13-.338h3.975c1.522 0 3.129.592 4.313 1.607",
    stroke: "#191A1E",
    strokeWidth: 0.846,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M300.611 71.637c0 4.99-3.975 9.05-8.965 9.135l-.93 4.144c-2.538-.338-5.413-.761-8.12-1.015l1.438-6.766c-1.1-1.523-1.776-3.383-1.776-5.413a9.097 9.097 0 0 1 9.134-9.135 9.044 9.044 0 0 1 9.219 9.05Z",
    fill: "#fff",
    stroke: "#191A1E",
    strokeWidth: 0.846,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M295.876 69.777a1.185 1.185 0 1 0-.001-2.369 1.185 1.185 0 0 0 .001 2.37Z",
    fill: "#191A1E"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M288.685 68.17c-1.269.761-2.199 2.199-2.453 3.721-.169 1.354.677 3.553 2.453 2.453",
    stroke: "#191A1E",
    strokeWidth: 0.846,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M361.932 127.967c-.846 1.692-2.03 3.468-4.145 3.468-1.86 0-11.841-.169-19.876-.338h-1.015l-7.612-.085c-2.114-3.721-2.03-8.458-2.03-9.473 0-1.945.17-9.134 5.075-12.263a9.42 9.42 0 0 1 2.876-1.185h9.896c5.243 0 3.806-1.353 8.457-4.144 2.707-1.522 5.329-.677 5.329-.677l-.508 4.314c2.453 0 4.652.507 4.821 2.368.17 1.523.254 3.975-1.268 4.99a3.783 3.783 0 0 1-1.523.592c.846-.084 1.776-.084 2.453.423 1.607 1.354.846 6.09-1.015 7.02-.93.423-1.691.508-2.706.592.761 0 1.607 0 2.368.254 1.691.677 1.015 2.707.423 4.144Z",
    fill: "#fff",
    stroke: "#191A1E",
    strokeWidth: 0.846,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "m360.411 115.533-5.075.085M361.255 123.568l-9.304.085M352.375 107.668h6.428c.169 0 .338 0 .507.085",
    stroke: "#191A1E",
    strokeWidth: 0.846,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "m781.36 166.185-126.023-23.006-149.704 63.265v59.979h459.263V134.552l-41.444 8.627-61.742-20.54-80.35 43.546Z",
    fill: "#EAEFF0"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M912.633 173 936 335H484l11.5-163 28.5-25 186 48 141-48 61.633 26Z",
    fill: "#fff"
  })));
};

export default SvgBackgroundImage;